import countries from '@/static/countries.json'

export const isCountryCodeValid = (code: string) => {
  return !!countries.find((country) => country.value === code)
}

export const isLanguageValid = (language: string) => {
  return ['en', 'jp'].includes(language)
}
